webpackJsonp([44,209,276],{

/***/ 1128:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-navbar', [_c('template', {
    slot: "brand"
  }, [_c('b-navbar-item', {
    attrs: {
      "tag": "router-link",
      "to": {
        path: '/'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "https://raw.githubusercontent.com/buefy/buefy/dev/static/img/buefy-logo.png",
      "alt": "Lightweight UI components for Vue.js based on Bulma"
    }
  })])], 1), _vm._v(" "), _c('template', {
    slot: "start"
  }, [_c('b-navbar-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                Home\n            ")]), _vm._v(" "), _c('b-navbar-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                Documentation\n            ")]), _vm._v(" "), _c('b-navbar-dropdown', {
    attrs: {
      "label": "Info"
    }
  }, [_c('b-navbar-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                    About\n                ")]), _vm._v(" "), _c('b-navbar-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                    Contact\n                ")])], 1)], 1), _vm._v(" "), _c('template', {
    slot: "end"
  }, [_c('b-navbar-item', {
    attrs: {
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('a', {
    staticClass: "button is-primary"
  }, [_c('strong', [_vm._v("Sign up")])]), _vm._v(" "), _c('a', {
    staticClass: "button is-light"
  }, [_vm._v("\n                        Log in\n                    ")])])])], 1)], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1441:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_navbar__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__examples_ExSimple__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__examples_ExSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple__ = __webpack_require__(1442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple__);
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            api: __WEBPACK_IMPORTED_MODULE_0__api_navbar__["default"],
            ExSimple: __WEBPACK_IMPORTED_MODULE_1__examples_ExSimple___default.a,
            ExSimpleCode: __WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple___default.a
        };
    }
});

/***/ }),

/***/ 1442:
/***/ (function(module, exports) {

module.exports = "<template>\n    <b-navbar>\n        <template slot=\"brand\">\n            <b-navbar-item tag=\"router-link\" :to=\"{ path: '/' }\">\n                <img\n                    src=\"https://raw.githubusercontent.com/buefy/buefy/dev/static/img/buefy-logo.png\"\n                    alt=\"Lightweight UI components for Vue.js based on Bulma\"\n                >\n            </b-navbar-item>\n        </template>\n        <template slot=\"start\">\n            <b-navbar-item href=\"#\">\n                Home\n            </b-navbar-item>\n            <b-navbar-item href=\"#\">\n                Documentation\n            </b-navbar-item>\n            <b-navbar-dropdown label=\"Info\">\n                <b-navbar-item href=\"#\">\n                    About\n                </b-navbar-item>\n                <b-navbar-item href=\"#\">\n                    Contact\n                </b-navbar-item>\n            </b-navbar-dropdown>\n        </template>\n\n        <template slot=\"end\">\n            <b-navbar-item tag=\"div\">\n                <div class=\"buttons\">\n                    <a class=\"button is-primary\">\n                        <strong>Sign up</strong>\n                    </a>\n                    <a class=\"button is-light\">\n                        Log in\n                    </a>\n                </div>\n            </b-navbar-item>\n        </template>\n    </b-navbar>\n</template>\n"

/***/ }),

/***/ 1443:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Example', {
    attrs: {
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode
    }
  }), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 219:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ([{
    title: 'Navbar',
    props: [{
        name: '<code>transparent</code>',
        description: 'Remove any hover or active background from the navbar items',
        type: 'Boolean',
        values: '—',
        default: 'false'
    }, {
        name: '<code>fixed-top</code>',
        description: 'Fixes the navbar to the top of the page',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>fixed-bottom</code>',
        description: 'Fixes the navbar to the bottom of the page',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>is-active</code>',
        description: 'To control the behaviour of the mobile menu programmatically, use the <code>.sync</code> modifier to make it two-way binding',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>type</code>',
        description: 'Type (color) of the background, optional',
        type: 'String, ',
        values: '<code>is-white</code>, <code>is-black</code>, <code>is-light</code>,\n                  <code>is-dark</code>, <code>is-primary</code>, <code>is-info</code>, <code>is-success</code>,\n                  <code>is-warning</code>, <code>is-danger</code>,\n                  and any other colors you\'ve set in the <code>$colors</code> list on Sass',
        default: '—'
    }, {
        name: '<code>wrapper-class</code>',
        description: 'To wrap the navbar content into an div with the provided class',
        type: 'String',
        values: '—',
        default: '—'
    }, {
        name: '<code>close-on-click</code>',
        description: 'Control the behavior of the mobile menu by clicking on a link or outside the menu',
        type: 'Boolean',
        values: '<code>true</code>, <code>false</code>',
        default: '<code>true</code>'
    }, {
        name: '<code>mobile-burger</code>',
        description: 'Use to display or not the burger on mobile resolution.',
        type: 'Boolean',
        values: '<code>true</code>, <code>false</code>',
        default: '<code>true</code>'
    }, {
        name: '<code>spaced</code>',
        description: 'Sets Top and Bottom paddings with 1rem, Left and Right paddings with 2rem',
        type: 'Boolean',
        values: '—',
        default: 'false'
    }, {
        name: '<code>shadow</code>',
        description: 'Add a shadow to navbar',
        type: 'Boolean',
        values: '—',
        default: 'false'
    }],
    slots: [{
        name: 'brand',
        description: 'The slot for the brand logo',
        props: '—'
    }, {
        name: 'burger',
        description: 'The slot for the burger that triggers the menu toggle',
        props: '<code>isOpened: Boolean</code>, <code>toggleActive: Function</code>'
    }, {
        name: 'start',
        description: 'Items that will appear on the left',
        props: '—'
    }, {
        name: 'end',
        description: 'Items that  will appear on the right',
        props: '—'
    }]
}, {
    title: 'Navbar Item',
    props: [{
        name: '<code>tag</code>',
        description: 'Sets the type of the component that have to render as navbar-item',
        type: 'String',
        values: '<code>a</code>, <code>router-link</code>, <code>div</code> and his html attributes like href, to, etc...',
        default: 'a'
    }, {
        name: '<code>active</code>',
        description: 'Item is active',
        type: 'Boolean',
        values: '-',
        default: 'false'
    }]
}, {
    title: 'Navbar Dropdown',
    props: [{
        name: '<code>hoverable</code>',
        description: 'Dropdown will be triggered by hover instead of click',
        type: 'Boolean',
        values: '-',
        default: 'false'
    }, {
        name: '<code>active</code>',
        description: 'Item is active',
        type: 'Boolean',
        values: '-',
        default: 'false'
    }, {
        name: '<code>right</code>',
        description: 'Dropdown will be anchored to the right side',
        type: 'Boolean',
        values: '-',
        default: 'false'
    }, {
        name: '<code>arrowless</code>',
        description: 'Show/hide arrow icon on dropdown',
        type: 'Boolean',
        values: '-',
        default: 'false'
    }, {
        name: '<code>boxed</code>',
        description: 'Show a boxed version of the dropdown',
        type: 'Boolean',
        values: '-',
        default: 'false'
    }],
    slots: [{
        name: 'default',
        description: 'Menu item body',
        props: '—'
    }, {
        name: '<code>label</code>',
        description: 'Dropdown menu custom label',
        props: '-'
    }]
}]);

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1128),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1441),
  /* template */
  __webpack_require__(1443),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/44.00f93e80947fd51aa0c6.js